export default "__VITE_ASSET__PYFbAxpg__"